import React, { useEffect, useState } from "react";
// import ServicesButtonList from "../components/ServicesButtonList";
import AOS from "aos";
import "aos/dist/aos.css";
import Schema from "./Schema";
import ServiceNavigator from "./ServiceNavigator";

const SolarPreventiveMaintaince = () => {
  useEffect(() => {
    AOS.init({ duration: 1000, once: true });
  }, []);

  const [expanded, setExpanded] = useState(false);
  const allItems = [
    "Poor wiring and installation errors",
    "Improper cleaning techniques",
    "Undocumented system modifications",
    "Physical damage from weather or animals",
    "Neglected inspections or maintenance logs",
    "Use of unapproved third-party equipment",
    "Ignoring early warning signs of malfunction",
    "Lack of shading analysis before installation",
  ];
  const visibleItems = expanded ? allItems : allItems.slice(0, 3);

  return (
    <div className="font-sans text-gray-900 bg-gray-100">
    <Schema />
      {/* Hero Section */}
      <section
        className="flex flex-col items-center gap-8 mt-16 mb-16 bg-black text-white rounded-3xl overflow-hidden mx-4 sm:mx-auto py-20 max-w-6xl text-center"
        data-aos="fade-up"
      >
        <div className="w-full max-w-3xl">
          <h2 className="text-5xl sm:text-5xl md:text-5xl lg:text-6xl font-bold mb-6">
            Solar Preventive Maintenance
          </h2>
          <p className="text-xl sm:text-2xl text-gray-300 mb-4">
            Extend the Life & Maximize the Savings of Your PV System
          </p>
          <p className="italic text-gray-400">
            Protect your solar investment with regular maintenance
          </p>
        </div>
      </section>

      {/* Informational Content */}
      <section
        className="px-6 py-14 max-w-4xl mx-auto text-lg leading-relaxed space-y-14"
        data-aos="fade-up"
      >
        <div>
        <h2 className="text-3xl sm:text-4xl md:text-5xl lg:text-6xl font-bold mb-8 text-black">
    Why Choose Solar Care International?
  </h2>
  <h2 className="text-xl sm:text-2xl md:text-3xl lg:text-4xl font-bold mb-8 text-black">
    Pioneers in Solar Preventive Maintenance & Coatings in Sri Lanka
  </h2>

  <p className="text-gray-700 mb-8">
    At Solar Care International, we are proud to be the exclusive introducer of the world’s first Antistatic Anti-adherent Protection Coating protecting applications by ChemiTek for Solar Panels in Sri Lanka and Maldives. These advanced products are officially approved by the top 17 solar PV panel manufacturers worldwide, ensuring complete compatibility, safety, and performance with the leading brands of solar technology.
  </p>

  <p className="text-gray-700 mb-8">
    This revolutionary coating protects the anti-reflective coating (ARC) from damage caused by dust, pollution, and bird droppings—delivering higher energy efficiency, reduced cleaning frequency, and extended panel lifespan.
  </p>

  <p className="text-gray-700 mb-8 mt-8">
    We are also the only company in Sri Lanka to deliver a comprehensive 41-Step Preventive Maintenance  Program, covering every aspect of solar aftercare:
    <br />✔ Professional cleaning & protective coatings
    <br />✔ Full system health audits & safety inspections
    <br />✔ Performance optimization for maximum output
    <br />✔ Warranty claim handling & long-term reliability
  </p>

  <p className="text-gray-700 mb-8">
    With international partnerships, certified European products, and unmatched international expertise, Solar Care International continues to lead Sri Lanka in innovative solar aftercare solutions.
  </p>

  <p className="text-gray-700 mb-8">
    As the exclusive authorized distributor of ChemiTek (Portugal) for Sri Lanka and Maldives, we bring world-class technology to protect your investment and safeguard a greener future.
  </p>

  <h2 className="text-3xl sm:text-4xl md:text-5xl lg:text-6xl font-bold mb-8 text-black">
    Why Preventive Maintenance?
  </h2>
  <p className="text-gray-700">
    “An ounce of prevention is better than a pound of cure.” This principle applies to your solar PV system too. While these systems are built to last for decades, issues like poor wiring, improper cleaning, or physical damage can lead to significant losses if left unchecked.
  </p>
</div>


        <div>
        <h2 className="text-3xl sm:text-4xl md:text-5xl lg:text-6xl font-bold mb-8 text-black">The Benefits</h2>
          <ul className="grid grid-cols-1 md:grid-cols-2 gap-6 text-base text-black">
            {[
              "Protects system efficiency for 25–35 years",
              "Prevents costly downtime and replacements",
              "Maintains warranty compliance",
              "Maximizes ROI on your solar investment",
            ].map((item, i) => (
              <li key={i} className="bg-white rounded-full px-6 py-4 text-center">
                {item}
              </li>
            ))}
          </ul>
        </div>
      </section>

      {/* Video and Text Split */}
      {/* Video and Text Section – Stacked Layout */}
      <section className="max-w-6xl mx-auto px-6 py-28 space-y-14" data-aos="fade-up">
        {/* Text Content */}
        <div className="space-y-6 text-gray-700">
          <h2 className="text-3xl sm:text-4xl md:text-5xl lg:text-6xl font-bold mb-8 text-black">
            Long-Term Peace of Mind
          </h2>
          <p>
            Preventive maintenance ensures uninterrupted solar production and long-term energy savings. Routine inspections, performance checks, and cleanings help avoid major issues.
          </p>
          <p className="italic">
            “Warranty coverage might protect you in some cases, but below are common issues usually excluded…”
          </p>

          <div>
            <h3 className="text-xl font-bold mb-3 text-gray-800">
              Your Solar Panel Warranty May Get Voided If:
            </h3>
            <ul className="list-disc list-inside text-gray-600 space-y-2">
              {visibleItems.map((item, idx) => (
                <li key={idx}>{item}</li>
              ))}
            </ul>
            <button
              className="mt-4 text-blue-600 font-semibold hover:underline"
              onClick={() => setExpanded(!expanded)}
              aria-expanded={expanded}
              aria-controls="warranty-issues-list"
            >
              {expanded ? "See less..." : "See more..."}
            </button>
          </div>
        </div>

        {/* Video Content */}
        <div className="rounded-3xl overflow-hidden shadow-lg">
          <video
            src="https://res.cloudinary.com/dwf8ifbzs/video/upload/v1749474377/WhatsApp_Video_2025-06-09_at_6.33.49_PM_byws29.mp4"
            className="w-full h-auto"
            autoPlay
            muted
            loop
            playsInline
          >
            Your browser does not support the video tag.
          </video>
        </div>
      </section>


      {/* Call to Action Section */}
      <section className="py-24 px-6 text-center max-w-4xl mx-auto" data-aos="fade-up">
        <h2 className="text-4xl md:text-6xl font-bold bg-gradient-to-r from-yellow-400 via-pink-400 to-yellow-300 bg-clip-text text-transparent mb-10 p-4">
          Book Your Preventive Maintenance Today
        </h2>
        <p className="text-gray-700 mb-6 text-lg">
          Ensure optimal performance of your PV system. Schedule a service with SolarCare International today and enjoy worry-free energy for decades.
        </p>
      </section>

      {/* Image Gallery Section */}
      <section className="px-6 py-14 max-w-6xl mx-auto space-y-12" data-aos="fade-up">
        <h2 className="text-3xl sm:text-4xl md:text-5xl lg:text-6xl font-bold text-center text-black">
          On-Site Maintenance Highlights
        </h2>

        <div className="grid grid-cols-1 sm:grid-cols-2 gap-8">
          {/* <img
            src="https://res.cloudinary.com/dwf8ifbzs/image/upload/v1751365413/WhatsApp_Image_2025-06-15_at_3.56.04_PM_hytfpp.jpg"
            alt="Maintenance 1"
            className="rounded-3xl shadow-lg transition-transform duration-300 hover:scale-105 w-full object-cover"
          /> */}
          <img
            src="https://res.cloudinary.com/dwf8ifbzs/image/upload/v1751365412/WhatsApp_Image_2025-06-15_at_3.56.17_PM_ymm0tk.jpg"
            alt="Maintenance 2"
            className="rounded-3xl shadow-lg transition-transform duration-300 hover:scale-105 w-full object-cover"
          />
          <img
            src="https://res.cloudinary.com/dwf8ifbzs/image/upload/v1751365411/WhatsApp_Image_2025-06-15_at_3.56.05_PM_s53d3p.jpg"
            alt="Maintenance 3"
            className="rounded-3xl shadow-lg transition-transform duration-300 hover:scale-105 w-full object-cover"
          />
          <img
            src="https://res.cloudinary.com/dwf8ifbzs/image/upload/v1751365410/WhatsApp_Image_2025-06-15_at_3.53.38_PM_ehnken.jpg"
            alt="Maintenance 4"
            className="rounded-3xl shadow-lg transition-transform duration-300 hover:scale-105 w-full object-cover"
          />
        </div>
      </section>


      {/* Contact Section */}
      <section
        className="flex flex-col items-center gap-8 mt-16 mb-16 bg-black text-white rounded-3xl overflow-hidden mx-4 sm:mx-auto py-20 max-w-6xl text-center"
        data-aos="fade-up"
      >
        <div className="w-full max-w-2xl">
          <div className="w-full max-w-2xl">
          <h2 className="text-3xl sm:text-4xl md:text-5xl lg:text-6xl font-bold mb-8">
            Get in Touch
          </h2>
          <p className="mb-2 font-medium">Solar Care International Pvt Ltd</p>
          <p className="mb-1">No.44/1A, Chapel Lane, Nugegoda, Sri Lanka</p>
          <p className="mb-1">+94 114 199 225 / +94 777 129 021</p>
          <p>
            <a
              href="mailto:info@solarcareinternational.com"
              className="text-blue-400 hover:text-blue-200 underline transition"
            >
              info@solarcareinternational.com
            </a>
          </p>
        </div>
        </div>
      </section>

      {/* <ServicesButtonList /> */}
      <ServiceNavigator />
    </div>
  );
};

export default SolarPreventiveMaintaince;